import { useQuery } from '@tanstack/react-query';
import { getLatLon, GetLatLonReqType } from '../services/location.ts';

export function useLatLon(query: GetLatLonReqType['query']) {
  return useQuery({
    queryKey: ['lat-lon', query],
    queryFn: async ({ signal }) => {
      return getLatLon({ signal, query });
    },
  });
}
